import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, {encode: false});
        },
    };

    return axios.get(`${url}/activityLabourerWorkplaces`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/activityLabourerWorkplaces/${id}`, options)
        .then(response => {
            let activityLabourerWorkplace = jsona.deserialize(response.data);
            delete activityLabourerWorkplace.links;
            console.log(activityLabourerWorkplace);
            return activityLabourerWorkplace;
        });
}

function view(payload) {
    const {id, ...queryParams} = payload;
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
        params: queryParams
    };

    return axios.get(`${url}/activityLabourerWorkplaces/${id}`, options)
        .then(response => {
            let activityLabourerWorkplace = jsona.deserialize(response.data);
            delete activityLabourerWorkplace.links;
            console.log(activityLabourerWorkplace);
            return activityLabourerWorkplace;
        });
}


function show(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/activityLabourerWorkplaces/${id}`, options)
        .then(response => {
            let activityLabourerWorkplace = jsona.deserialize(response.data);
            delete activityLabourerWorkplace.links;
            return activityLabourerWorkplace;
        });
}

function add(activityLabourerWorkplace) {
    console.log('toBeSaved:services',activityLabourerWorkplace);
    activityLabourerWorkplace.relationships =   {
        labourer: {
            data: {
                type: 'labourers',
                    id: activityLabourerWorkplace.labourer_id
            }
        },
        workplace: {
            data: {
                type: 'workplaces',
                    id: activityLabourerWorkplace.workplace_id
            }
        },
        activity: {
            data: {
                type: 'activities',
                    id: activityLabourerWorkplace.activity_id
            }
        }
    }
    const payload = jsona.serialize({
        stuff: activityLabourerWorkplace,
        includeNames: ['activity', 'labourer', 'workplace', 'creator']
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/activityLabourerWorkplaces`, payload, options)
        .then(response => {
            const deserialized = jsona.deserialize(response.data);
            return deserialized;
        });
}

function update(activityLabourerWorkplace) {
    const payload = jsona.serialize({
        stuff: activityLabourerWorkplace,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };
    return axios.patch(`${url}/activityLabourerWorkplaces/${activityLabourerWorkplace.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/activityLabourerWorkplaces/${id}`, options);
}

export default {
    list,
    get,
    view,
    show,
    add,
    update,
    destroy
};

